import React, {useCallback, useEffect, useState} from 'react'
import {MunshiMenu} from "../components/Menu";
import {Button} from 'primereact/button';
import {axiosInstance} from "../utilities/AxiosConfig";
import {DataTable} from 'primereact/datatable';
import {ToastContainer} from 'react-toastify';
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";
import {RadioButton} from "primereact/radiobutton";
import {Column} from "primereact/column";
import {ViewImages} from "../components/Image/ImageUtils";
import {LedgerPrint} from "../print/LedgerPrint";
import {CustomerSelect} from "../components/Select/CustomerSelect";
import {PickDateRange} from "../components/Select/DateRangeSelect";
import Cookies from "js-cookie";
import {FloatLabel} from "primereact/floatlabel";
import {Auths} from "../utilities/getAuthDep";
import {formatDateToMySql} from "../utilities/ToMySqlDate";

export function CustomerLedger({handle}) {
    const {loading, setLoading} = useSpinner();
    const [action, setAction] = useState(null);
    const [customer, setCustomer] = useState({id: 0, name: "", initialBalance: 0, customerGroup: 0});
    const [proceed, setProceed] = useState(false);
    const [customerList, setCustomerList] = useState([]);
    const [ledger, setLedger] = useState([]);
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");

    const [showLedger, setShowLedger] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [bioData, setBioData] = useState({});
    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [bioRes] = await Promise.all([
                    axiosInstance.get('biodata/'),
                ]);
                setBioData(bioRes.data);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);
    useEffect(() => {
        setLoading(true)
        setUser(Cookies.get('user') || "Zubair");
        setDatabase(Cookies.get('database') || "Test");
        setLoading(false)
    }, [])
    // Loading Handle

    // Load Customer List
    useEffect(() => {
        const checkAction = async () => {
            if (action) {
                resetPage()
                setProceed(false)
                setLoading(true)
                switch (action) {
                    case "Customer": {
                        await axiosInstance.get(`customer/`).then((response) => {
                            if (response.data && response.data.length > 0) {
                                setCustomerList(response.data)
                            } else {
                                notify("No Balance Found", "error")
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(
                            () => {
                                setLoading(false)
                                setProceed(true)
                            }
                        )
                        break;
                    }
                    case "Expenditure": {
                        await axiosInstance.get(`/customer/status/E`).then((response) => {
                            if (response.data && response.data.length > 0) {
                                setCustomerList(response.data)
                            } else {
                                notify("No customer found", "error")
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(() => {
                                setLoading(false)
                                setProceed(true)
                            }
                        )
                        break;
                    }
                    case "Assets": {
                        await axiosInstance.get(`/customer/status/A`).then((response) => {
                            if (response.data && response.data.length > 0) {
                                setCustomerList(response.data)
                            } else {
                                notify("No customer found", "error")
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(() => {
                                setLoading(false)
                                setProceed(true)
                            }
                        )
                        break;
                    }
                    case "Bank" : {
                        await axiosInstance.get(`/customer/status/B`).then((response) => {
                            if (response.data && response.data.length > 0) {
                                setCustomerList(response.data)
                            } else {
                                notify("No customer found", "error")
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(() => {
                            setLoading(false)
                            setProceed(true)
                        })
                        break;
                    }
                    case "Import" : {
                        await axiosInstance.get(`/customer/status/I`).then((response) => {
                            if (response.data && response.data.length > 0) {
                                setCustomerList(response.data)
                            } else {
                                notify("No customer found", "error")
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(() => {
                            setLoading(false)
                            setProceed(true)
                        })
                        break;
                    }
                    case "Other" : {
                        await axiosInstance.get(`/customer/status/D`).then((response) => {
                            if (response.data && response.data.length > 0) {
                                setCustomerList(response.data)
                            } else {
                                notify("No customer found", "error")
                            }
                        }).catch((error) => {
                            notify(error.message, "error")
                        }).finally(() => {
                            setLoading(false)
                            setProceed(true)
                        })
                        break;
                    }
                    default: {
                        setProceed(false)
                        setCustomerList([])

                    }
                }
            }
        }
        checkAction().then(setLoading(false));

    }, [action, setAction])
    const handlePrintOptions = () => {
        const dateString = dates[0].toLocaleDateString() + " - " + dates[1].toLocaleDateString()
        switch (action) {
            case "Cash": {
                LedgerPrint(ledger, bioData.name, "CASH", dateString)
                break;
            }
            case "Cheque": {
                LedgerPrint(ledger, bioData.name, 'CHEQUE', dateString)
                break;
            }
            case "Sales": {
                LedgerPrint(ledger, bioData.name, "SALES", dateString)
                break;
            }
            case "Purchase": {
                LedgerPrint(ledger, bioData.name, "PURCHASE", dateString)
                break;
            }

            case "Voucher": {
                LedgerPrint(ledger, bioData.name, "VOUCHER", dateString)
                break;
            }
            case "CashBook": {
                LedgerPrint(ledger, bioData.name, "CASHBOOK", dateString)
                break;
            }
            default: {
                LedgerPrint(ledger, bioData.name, customer.name, dateString)
            }
        }
    }
    // Load Ledger
    const ledgerHeader = () => {
        const dateString = dates[0].toLocaleDateString() + " - " + dates[1].toLocaleDateString()
        return (
            <div className="flex justify-content-end">
                <Button icon="pi pi-print" className="mr-1 pr-2"
                        onClick={() => LedgerPrint(ledger, bioData.name, customer.name, dateString)}
                        disabled={!proceed || ledger.length === 0}/>
            </div>
        );
    };
    const loadCashLedger = () => {
        setLoading(true)
        axiosInstance.get(`/ledger/cash/${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
            if (response.data && response.data.length > 0) {
                setLedger(response.data)
                setShowLedger(true)
                setProceed(true)
            } else {
                setProceed(false)
                notify("No Ledger Found", "error")
            }
        }).catch((error) => {
            setProceed(false)
            notify(error.message, "error")
        }).finally(() => {
            setLoading(false)
        })
    }
    const loadSalesLedger = () => {
        setLoading(true)
        axiosInstance.get(`/ledger/sales/${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
            if (response.data && response.data.length > 0) {
                setLedger(response.data)
                setShowLedger(true)
                setProceed(true)
            } else {
                setProceed(false)
                notify("No Ledger Found", "error")
            }
        }).catch((error) => {
            setProceed(false)
            notify(error.message, "error")
        }).finally(() => {
            setLoading(false)
        })
    }
    const loadPurchaseLedger = () => {
        setLoading(true)
        axiosInstance.get(`/ledger/purchase/${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
            if (response.data && response.data.length > 0) {
                setLedger(response.data)
                setShowLedger(true)
                setProceed(true)
            } else {
                setProceed(false)
                notify("No Ledger Found", "error")
            }
        }).catch((error) => {
            setProceed(false)
            notify(error.message, "error")
        }).finally(() => {
            setLoading(false)
        })
    }
    const loadVoucherLedger = () => {
        setLoading(true)
        axiosInstance.get(`/ledger/voucher/${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
            if (response.data && response.data.length > 0) {
                setLedger(response.data)
                setShowLedger(true)
                setProceed(true)
            } else {
                notify("No Ledger Found", "error")
                setProceed(false)
            }
        }).catch((error) => {
            notify(error.message, "error")
            setProceed(false)
        }).finally(() => {
            setLoading(false)
        })
    }
    const loadCashBookLedger = () => {
        setLoading(true)
        axiosInstance.get(`/ledger/cashbook/${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
            if (response.data && response.data.length > 0) {
                setLedger(response.data)
                setShowLedger(true)
                setProceed(true)
            } else {
                setProceed(false)
                notify("No Ledger Found", "error")
            }
        }).catch((error) => {
            setProceed(false)
            notify(error.message, "error")
        }).finally(() => {
            setLoading(false)
        })
    }
    const loadChequeLedger = () => {
        setLoading(true)
        axiosInstance.get(`/ledger/cheque/${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
            if (response.data && response.data.length > 0) {
                setLedger(response.data)
                setShowLedger(true)
                setProceed(true)
            } else {
                setProceed(false)
                notify("No Ledger Found", "error")
            }
        }).catch((error) => {
            setProceed(false)
            notify(error.message, "error")
        }).finally(() => {
            setLoading(false)
        })
    }
    const loadCustomerLedger = (id) => {
        if (Number(id) > 0) {
            setLoading(true)
            axiosInstance.get(`/ledger/${id}&${formatDateToMySql(dates[0])}&${formatDateToMySql(dates[1])}`).then((response) => {
                if (response.data && response.data.length > 0) {
                    setLedger(response.data)
                    setShowLedger(true)
                    setProceed(true)
                } else {
                    setProceed(false)
                    notify("No Ledger Found", "error")
                }
            }).catch((error) => {
                setProceed(false)
                notify(error.message, "error")
            }).finally(() => {
                setLoading(false)
            })
        } else {
            setProceed(false)
            notify("No Customer Found", "error")
        }
    }
    const applyAction = () => {
        setLoading(true)
        switch (action) {
            case "Cash": {
                loadCashLedger()
                break;
            }
            case "Cheque": {
                loadChequeLedger()
                break;
            }
            case "Sales": {
                loadSalesLedger()
                break;
            }
            case "Purchase": {
                loadPurchaseLedger()
                break;
            }
            case "Voucher": {
                loadVoucherLedger()
                break;
            }
            case "CashBook": {
                loadCashBookLedger()
                break;
            }
            default: {
                loadCustomerLedger(customer.id)

            }
        }
        setProceed(true)
        setLoading(false)

    }
    const resetPage = useCallback(() => {
        setLedger([])
        setProceed(false)
        setShowLedger(false)

        setCustomer({id: 0, name: "", initialBalance: 0, customerGroup: 0})
        setDates([new Date(), new Date()])
        setCustomerList([])
        setLoading(false)

    })
        const OptionSelect = () => {
            return (
                <div className="card shadow-2 border-round-md p-3 mb-3 bg-white">
                    <div className="flex flex-column lg:flex-row gap-4 align-items-center justify-content-between">
                        
                        {/* Action Buttons Group */}
                        <div className="flex flex-row gap-2">
                            <Button 
                                label="Proceed" 
                                icon="pi pi-check-circle" 
                                className="p-button-sm p-button-raised"
                                onClick={() => applyAction()}
                                disabled={!action || (["Customer", "Expenditure", "Assets", "Bank", "Other"].includes(action) && customer.id === 0)}
                            />
                            <Button 
                                label="Reset" 
                                icon="pi pi-refresh" 
                                className="p-button-sm p-button-outlined p-button-secondary"
                                onClick={() => resetPage()}
                            />
                            <Button 
                                icon="pi pi-print" 
                                className="p-button-sm p-button-outlined"
                                onClick={() => handlePrintOptions()}
                                disabled={ledger.length === 0}
                            />
                        </div>

                        {/* Radio Options Grid */}
                        <div className="flex flex-wrap gap-4 justify-content-center lg:justify-content-end flex-grow-1">
                            
                            {/* Group: Categories */}
                            <div className="flex align-items-center gap-3 bg-gray-50 p-2 border-round">
                                <span className="text-xs font-bold text-500 uppercase mr-2 border-right-1 pr-2">Entities</span>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="1" name="action" value="Customer" onChange={(e) => setAction(e.value)} checked={action === 'Customer'} disabled={(level) === "None"}/>
                                    <label htmlFor="1" className="ml-2 text-sm cursor-pointer">Customer</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="2" name="action" value="Expenditure" onChange={(e) => setAction(e.value)} checked={action === 'Expenditure'} disabled={!level.cashier()}/>
                                    <label htmlFor="2" className="ml-2 text-sm cursor-pointer">Expenses</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="3" name="action" value="Assets" onChange={(e) => setAction(e.value)} checked={action === 'Assets'} disabled={!level.cashier()}/>
                                    <label htmlFor="3" className="ml-2 text-sm cursor-pointer">Assets</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="4" name="action" value="Bank" onChange={(e) => setAction(e.value)} checked={action === 'Bank'} disabled={!level.cashier()}/>
                                    <label htmlFor="4" className="ml-2 text-sm cursor-pointer">Bank</label>
                                </div>
                            </div>

                            {/* Group: Operations */}
                            <div className="flex align-items-center gap-3 bg-gray-50 p-2 border-round">
                                <span className="text-xs font-bold text-500 uppercase mr-2 border-right-1 pr-2">Books</span>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="6" name="action" value="Cash" onChange={(e) => setAction(e.value)} checked={action === 'Cash'} disabled={!level.cashier()}/>
                                    <label htmlFor="6" className="ml-2 text-sm cursor-pointer">Cash</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="13" name="action" value="Cheque" onChange={(e) => setAction(e.value)} checked={action === 'Cheque'} disabled={!level.cashier()}/>
                                    <label htmlFor="13" className="ml-2 text-sm cursor-pointer">Cheques</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="8" name="action" value="Sales" onChange={(e) => setAction(e.value)} checked={action === 'Sales'} disabled={!level.cashier() && !level.inventory()}/>
                                    <label htmlFor="8" className="ml-2 text-sm cursor-pointer">Sales</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="9" name="action" value="Purchase" onChange={(e) => setAction(e.value)} checked={action === 'Purchase'} disabled={!level.inventory()}/>
                                    <label htmlFor="9" className="ml-2 text-sm cursor-pointer">Purchase</label>
                                </div>
                                <div className="flex align-items-center">
                                    <RadioButton inputId="11" name="action" value="CashBook" onChange={(e) => setAction(e.value)} checked={action === 'CashBook'} disabled={!level.cashier()}/>
                                    <label htmlFor="11" className="ml-2 text-sm cursor-pointer">CashBook</label>
                                </div>

                                <div className="flex align-items-center">
                                    <RadioButton inputId="12" name="action" value="Voucher" onChange={(e) => setAction(e.value)} checked={action === 'Voucher'} disabled={!level.cashier()}/>
                                    <label htmlFor="12" className="ml-2 text-sm cursor-pointer">Voucher</label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            );
        }
    const OptionLedgerSelect = () => {
        if (!loading) {
            return (
                <>
                    <div
                        className=" container shadow-5  border-round-md flex-wrap w-full flex-grow-1 flex-row justify-content-center p-1 md:left-50 md:w-5 ">
                        <div className="flex flex-row justify-content-evenly p-2  ml-5 mr-5">
                            {(action !== "Cash" && action !== "Cheque" && action !== "Sales" && action !== "Purchase" && action !== "Voucher" && action !== "CashBook") &&
                                <FloatLabel>
                                    <CustomerSelect id="cs" customer={customer || {id: 0, name: ""}}
                                                    setCustomer={setCustomer}
                                                    customerList={customerList}
                                                    disable={false}/>
                                    <label htmlFor="cs">Select Customer</label>
                                </FloatLabel>}
                            <FloatLabel>
                                <PickDateRange id="dr" dates={dates} setDates={setDates}
                                               disable={action !== "Cash" && action !== "Cheque" && action !== "Sales" && action !== "Purchase" && action !== "Voucher" && action !== "CashBook" && customer === null}/>
                                <label htmlFor="dr">Select Date Range</label>
                            </FloatLabel>
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <div className="flex flex-row justify-content-center">
                    <h1>Loading...</h1>
                </div>
            )
        }

    }
    const ShowLedger = () => {
        const [showImage, setShowImage] = useState(false)
        const [mode, setMode] = useState("")
        const [invoiceId, setInvoiceId] = useState(0)
        const handleTableClick = (data) => {
            setMode(data.data.mode==="VCHR"?"VOUC":data.data.mode)
            setInvoiceId(data.data.invoiceId)
            if (data.data.invoiceId > 0) {
                setShowImage(true)
            }

        }
        if (ledger.length === 0) {
            return (
                <div className="card">
                    <div className="flex flex-row justify-content-center">
                        <h1>No Ledger Found</h1>
                    </div>
                </div>
            )
        } else if (showImage) {
            return (
                <>
                    {showImage ? <ViewImages invoice={invoiceId} mode={mode} showImage={showImage}
                                             setShowImage={setShowImage}/> : null}

                </>
            )
        } else {
            return (
                <>
                    <div className="card w-full h-full">
                        <DataTable value={ledger} tableStyle={{minWidth: '50rem'}} showGridlines
                                   className="p-datatable-striped p-datatable-gridlines w-full  "
                                   style={{fontSize: '10px'}} selectionMode="single" scrollable={true}
                                   scrollHeight="70vh"
                                   size={"small"}
                                   stripedRows onRowClick={(e) => handleTableClick(e)}
                        >
                            <Column className="text-left text-xs " field="date" header="Date"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    style={{width: '15%'}}></Column>
                            <Column className="text-left text-xs " field="invoiceId" header="Folio"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    style={{width: '5%'}}></Column>
                            {action === "Cash" || action === "Cheque" || action === "Voucher" ? (
                                <Column className="text-left text-xs" field="customerName" header="Customer"
                                        headerStyle={{backgroundColor: '#f0f0f0'}}
                                        style={{width: '10%'}}></Column>) : (
                                <Column className="text-left text-xs" field="mode" header="Mode"
                                        headerStyle={{backgroundColor: '#f0f0f0'}}
                                        style={{width: '5%'}}></Column>)}

                            <Column className="text-end text-xs" field="debit" header="Debit"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    alignHeader="right" style={{width: '15%'}}></Column>
                            <Column className="text-end text-xs" field="credit" header="Credit"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    alignHeader="right" style={{width: '15%'}}></Column>
                            <Column className="text-end text-xs" field="total" header="Balance"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    alignHeader="right" style={{width: '20%'}}></Column>
                            {action !== "Cash" && action !== "Cheque" &&(<Column className="text-left text-xs" field="department" header="Department"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    style={{width: '10%'}}></Column>)}
                            <Column className="text-left text-xs " field="comments" header="Comment"
                                    headerStyle={{backgroundColor: '#f0f0f0'}}
                                    style={{width: '15%'}}></Column>
                        </DataTable>

                    </div>
                </>
            )
        }

    }
    if (!loading) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                <div className="flex flex-column justify-content-start   h-auto w-full ml-2 mr-2">
                    <div className="flex flex-column">
                        <OptionSelect/>
                        {action && <OptionLedgerSelect/>}
                    </div>
                    <div className="flex flex-row justify-content-start w-full">
                        {showLedger &&
                            <div className="flex flex-row justify-content-start w-full mr-2 ml-2">
                                <ShowLedger/></div>}
                    </div>
                </div>
            </>
        )
    }

}

export default CustomerLedger;
